import Container from '../../atoms/container/keySpace';
import Icon from '../../atoms/icons/spaceBar';
import VirtualKeyboardContext from '../../../../shared/components/utils/context/virtualKeyboardContext';
import { selectMagicRemoteEnabled } from '../../../../shared/store/slices/magicRemote.slice';
import { useAppSelector } from '../../../../shared/store/hooks';
import { useContext, useState } from 'react';

function SpaceKey({
  index,
  alternateKeyboard = false,
}: {
  char: string;
  index: number[];
  alternateKeyboard?: boolean;
}) {
  const enabled = useAppSelector(selectMagicRemoteEnabled);
  const { listIndex, listFocused, onClick } = useContext(
    VirtualKeyboardContext
  );
  const [hovered, setHovered] = useState(false);
  const focused = !enabled && listFocused && index.includes(listIndex);
  return (
    <Container
      onClick={() => index.length && onClick(index[0])}
      onPointerEnter={() => setHovered(true)}
      onPointerLeave={() => setHovered(focused)}
      alternateKeyboard={alternateKeyboard}
    >
      <Icon focused={focused || hovered} />
    </Container>
  );
}

export default SpaceKey;
